import { Document, INLINES } from '@contentful/rich-text-types';
import { Box } from '@zoopla-eng/zds-components/box';
import { ArrowRightSmall } from '@zoopla-eng/zds-components/icons';
import { LinkWithIcon } from '@zoopla-eng/zds-components/link';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import {
    gridStyle,
    headingStyle,
    listItemStyle,
    listStyle,
    wrapperStyle,
} from './SeoLinkList.styles.css';

type Props = {
    heading: string;
    text?: string;
    icon?: React.ReactNode;
    links: Document;
};

const IconLink = ({
    href,
    children,
}: {
    href: string;
    children: React.ReactNode;
}) => (
    <LinkWithIcon
        unweighted={true}
        href={href}
        muted
        iconPrefix={<ArrowRightSmall />}
    >
        {children}
    </LinkWithIcon>
);

const documentToIconLinks = (doc: Document) => {
    const nodeType = INLINES.HYPERLINK;

    type Entry = {
        nodeType: string;
        content?: Entry[];
        data?: { uri?: string };
        value?: string;
    };

    const result: Entry[] = [];

    const recursiveCrawl = (next: Entry[], content: Entry) => {
        if (content.nodeType === nodeType) {
            next.push(content);
        }
        if (content?.content) {
            content.content.forEach((c) => recursiveCrawl(next, c));
        }
    };

    recursiveCrawl(result, doc);

    return result.map(({ data, content }) => ({
        href: data?.uri || '',
        title: (content && content[0]?.value) || '',
        location: data?.uri?.split('/').pop() || '',
    }));
};

export const SeoLinkList = ({ links, heading, text, icon }: Props) => {
    const iconLinks = documentToIconLinks(links);

    return (
        <div className={wrapperStyle}>
            <div className={gridStyle}>
                <Box
                    display="flex"
                    columnGap="S400"
                    pb="S500"
                    bpM100={{ pb: 0 }}
                >
                    {icon && icon}

                    <Box>
                        <h3 className={`${headingStyle} ${fontGroups.mug}`}>
                            {heading}
                        </h3>
                        {text && <p className={fontGroups.ladle}>{text}</p>}
                    </Box>
                </Box>

                <ul className={listStyle}>
                    {iconLinks
                        .slice(0, Math.ceil(iconLinks.length / 2))
                        .map((link, i) => (
                            <li className={listItemStyle} key={i}>
                                <IconLink href={link.href}>
                                    {link.title}
                                </IconLink>
                            </li>
                        ))}
                </ul>
                <ul className={listStyle}>
                    {iconLinks
                        .slice(Math.ceil(iconLinks.length / 2))
                        .map((link, i) => (
                            <li className={listItemStyle} key={i}>
                                <IconLink href={link.href}>
                                    {link.title}
                                </IconLink>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    );
};
